export default {
  computed: {
    expandedRows() {
      return this.tableData.reduce((accumulator, item) => {
        if (!item.categoryIds) {
          accumulator.push(item.category);
        }
        return accumulator;
      }, []);
    },
    translatedTableData() {
      this.translateTableData(this.tableData);
      return this.tableData;
    },
  },
  methods: {
    translateTableData(tableRows) {
      if (tableRows) {
        tableRows.forEach(tableRow => {
          tableRow.category = this.$t(tableRow.translationKey);
          if (tableRow.items) {
            this.translateTableData(tableRow.items);
          }
        });
      }
    },
    getTranslatedColumns(columns) {
      if (columns) {
        columns.forEach(column => {
          if (column.translationKey) {
            column.title = this.$t(column.translationKey);
          }
        });
        return columns;
      }
      return [];
    },
  },
};
